// Tipos para Baterias Automotivas

export interface Battery {
  id: string
  slug: string
  name: string
  brand?: string
  model?: string
  capacity: number | null // Amperagem (Ah)
  voltage: number | null // Voltagem (V)
  dimensions: {
    length: number // mm
    width: number  // mm
    height: number // mm
  }
  weight: number // kg
  price: number
  originalPrice?: number
  discount?: number
  images: string[]
  description: string
  specifications: BatterySpecification[]
  compatibleVehicles: VehicleCompatibility[]
  stock: number
  isActive: boolean
  allowsScrapReturn?: boolean
  scrapReturnEnabled?: boolean | null
  category: BatteryCategory
  tags: string[]
  rating: number
  reviewCount: number
  createdAt: Date
  updatedAt: Date
}

export interface BatterySpecification {
  name: string
  value: string
  unit?: string
}

export interface VehicleCompatibility {
  brand: string
  model: string
  year: {
    from: number
    to: number
  }
  engine?: string
}

export interface BatteryCategory {
  id: string
  name: string
  slug: string
  description?: string
}

export interface BatteryFilter {
  brand?: string[]
  capacity?: {
    min: number
    max: number
  }
  voltage?: number[]
  price?: {
    min: number
    max: number
  }
  category?: string[]
  inStock?: boolean
}

export interface BatterySearchParams {
  query?: string
  filters?: BatteryFilter
  sortBy?: 'price' | 'name' | 'rating' | 'capacity'
  sortOrder?: 'asc' | 'desc'
  page?: number
  limit?: number
}

// Tipos para Reviews
export interface BatteryReview {
  id: string
  batteryId: string
  userId: string
  userName: string
  rating: number // 1-5
  title: string
  comment: string
  images?: string[]
  verifiedPurchase: boolean
  helpful: number
  createdAt: Date
  updatedAt: Date
}

// Tipos para Cupons
export interface Coupon {
  id: string
  code: string
  name: string
  description: string
  type: 'percentage' | 'fixed' | 'free_shipping'
  value: number
  minOrderValue?: number
  maxDiscount?: number
  usageLimit?: number
  usedCount: number
  validFrom: Date
  validUntil: Date
  isActive: boolean
  applicableProducts?: string[] // IDs das baterias
  applicableCategories?: string[] // IDs das categorias
}

// Tipos para Carrinho
export interface CartItem {
  batteryId: string
  quantity: number
  price: number
  appliedCoupon?: string
}

export interface Cart {
  items: CartItem[]
  subtotal: number
  discount: number
  shipping: number
  total: number
  appliedCoupons: string[]
}

// Tipos para Pedidos
export interface Order {
  id: string
  userId: string
  items: CartItem[]
  subtotal: number
  discount: number
  shipping: number
  total: number
  status: OrderStatus
  paymentMethod: PaymentMethod
  shippingAddress: Address
  billingAddress: Address
  trackingCode?: string
  createdAt: Date
  updatedAt: Date
}

export enum OrderStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  CONFIRMED = 'confirmed',
  RETURNED = 'returned',
  READY_FOR_PICKUP = 'ready_for_pickup',
}

export enum PaymentMethod {
  PIX = 'pix',
  CREDIT_CARD = 'credit_card',
  DEBIT_CARD = 'debit_card',
  BOLETO = 'boleto',
}

export enum PaymentStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  AUTHORIZED = 'authorized',
  PAID = 'paid',
  COMPLETED = 'completed',
  REFUNDED = 'refunded',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  CANCELED = 'canceled',
  CHARGEBACK = 'chargeback',
}

export interface Address {
  street: string
  number: string
  complement?: string
  neighborhood: string
  city: string
  state: string
  zipCode: string
  country: string
}

// Tipos para Usuário
export interface User {
  id: string
  name: string
  email: string
  phone?: string
  addresses: Address[]
  orders: string[] // IDs dos pedidos
  createdAt: Date
  updatedAt: Date
}
